<template>
    <div class="content v-touch" >
        <!--        培训组织方-->
        <div class="organizer_list">
            <div class="organizer">项目组织方
                <img src="../../../assets/home/shops/biaozhi1.png" class="organizer_img"/></div>
            <div class="organizer_name">仪海仪家互联网平台</div>
            <div class="organizer_name">麦谱科技(北京)有限公司
            </div>
            <div class="organizer_name">
                &nbsp;&nbsp;上海艾茵精密仪器科技有限公司</div>


        </div>
        <!-- 培训项目 -->
        <div>
            <div class="programa">培训项目</div>
            <div class="program_a">1.赛默飞系列产品,包括离子色谱、气相色谱、
                液相色谱、GC-MS、LC-MS、ICP-MS、ICP等全线产品。
            </div>
            <div class="program_a">2.安捷伦系列产品,包括气相色谱、液相色谱、
                GC-MS、LC-MS、ICP-MS等全线产品。
            </div>
            <div class="program_a">3.后期会根据需要增加其它系列产品培训，目前主要围绕
                赛默飞和安捷伦系列产品线。
            </div>
            <div class="program_a">4.培训内容包括：理论知识、上机实操、仪器拆解组装、
                产品应用,总之绝对是实实在在的干货。让你学到真正的仪器使用技能。
            </div>
        </div>
        <!-- 培训对象 -->
        <div>
            <div class="program">培训对象</div>
            <div class="program_a">各企业、高校、事业单位、科研院所等仪器等使用人员
                、管理人员及其它想学习的人。
            </div>
            <div class="program_name">社会上以仪器维修、维保服务为主业的个人、公司员工</div>
            <div class="organizer_name">将来想从事相关行业的任何个体</div>
        </div>
        <!-- 培训的宗旨 -->
        <div>
            <div class="program">培训的宗旨</div>
            <div class="organizer_name">让你学到真正的技能，让你的技能价值变现</div>
        </div>
        <!-- 参加方式 -->
        <div>
            <div class="program">免费参加的方式</div>
            <div class="program_b">无论是企业还是个人只要加入"仪海仪家"即可免费
                参加培训，加入仪海仪家的方式：登录网址：www.yi-mix.com，并完成实名认证
                或者扫描二维码，关注仪海仪家小程序，然后在网页端完成实名认证。
                （已经关注小程序的用户，网站登录账号和密码分别是手机号和手机号后六位，
                登录网站后完善相关信息即可。）
            </div>
        </div>
        <!-- 点击报名 -->

        <div class="dianji"  @click="dianjibm">点击报名>>
            <!--            <router-link :to="'/application/' +this.$route.params.id"></router-link>-->
        </div>
        <div class="yihyij">
            <div>仪海仪家小程序</div>
            <div>
                <img src="../../../assets/home/shops/xiaochengxu1.jpg"
                     style="width: 130px;height: 130px;margin-top: 25px;"/>
            </div>
        </div>


    </div>
</template>

<script>
    export default {

        methods: {
            dianjibm(){
                // this.$router.push({ path:'/application' })
                this.$router.push('/application/'+this.$route.params.id);
            },
        },
        created: function () {
            document.title = '仪海仪家仪器使用技能培训简介'
        }


    }
</script>

<style scoped>
    .content {
        background-image: url('~@/../src/assets/home/shops/beijing.png');
        /*background-size: 100% 100%;*/
        height: 100%;
        position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
        /*height: auto;*/
        font-family: SourceHanSansCN-Regular;
        text-align: center;

    }

    .organizer_list {
        overflow: hidden;
    }

    .organizer {
        color: #FFFFFF;
        font-size: 15px;
        margin-top: 26px;
    }

    .organizer_img {
        height: 16px;
        width: 61px;
        /*position: relative;*/
        /*top: -118px;*/
        /*left:130px;*/
    }

    .organizer_name {
        color: #BEE0FF;
        font-size: 12px;
        margin-top: 15px;
    }

    .program {
        margin-top: 18px;
        font-size:15px;
        color: #FFFFFF;

    }

    .programa {
        font-size: 15px;
        color: #FFFFFF;
        text-align: center;
        margin-top: 18px;

    }

    .program_name {
        color: #BEE0FF;
        margin-top: 14px;
        font-size: 12px;
        text-indent: 2em;

    }

    .program_b {
        margin-left: 19px;
        margin-right: 18px;
        color: #BEE0FF;
        margin-top: 13px;
        font-size: 12px;
        text-align: left;
    }

    .program_a {
        margin-left: 22px;
        margin-right: 18px;
        color: #BEE0FF;
        margin-top: 13px;
        font-size: 12px;
        text-indent: 1em;
        text-align: left;
    }

    .dianji {
        width: 139px;
        height: 37px;
        border: 3px solid #8FD9FF;
        background-color: #4E2FC0;
        border-radius: 10px;
        margin: auto;
        line-height: 30px;
        margin-top: 24px;
        font-size: 14px;
        color: #FFFFFF;
    }

    .yihyij {
        margin-top: 24px;
        color: #FFFFFF;
        padding-bottom: 35px;

    }

    @media screen and (min-width: 980px) {
        .program_a {
            text-align: center;
            color: #BEE0FF;
            margin-top: 13px;
            font-size: 12px;
            text-indent: 2em;

        }

        .program_b {
            text-align: center;
            color: #BEE0FF;
            margin-top: 13px;
            font-size: 12px;
        }
    }
</style>